














import { defineComponent } from "@vue/composition-api";
import { VaultCategory } from "@scrile/api-provider/dist/api/VaultsProvider";
import BaseIcon from "@/components/BaseIcon";
import VaultAiBadge from "../VaultAiBadge";
import VaultFiles from "../VaultFiles";

export default defineComponent({
  name: "VaultCategoryItem",
  components: { VaultAiBadge, BaseIcon, VaultFiles },
  props: {
    allowAi: { type: Boolean, default: false },
    category: { type: Object as () => VaultCategory, required: true },
  },
});
